function handleErrors(response) {
  if (response.ok) {
    return response;
  }
  throw Error(response.statusText);
}

export async function japiGet(path) {
  return fetch(`japi/${path}`).then(handleErrors).then((r) => r.json());
}
export async function japiPostInspection(path, args) {
  return fetch(`japi/${path}`, {
    headers: { 'Content-Type': 'application/json' },
    method: 'POST',
    body: JSON.stringify(args),
  }).then((r) => r.json());
}
export async function japiPost(path, args) {
  return fetch(`japi/${path}`, {
    headers: { 'Content-Type': 'application/json' },
    method: 'POST',
    body: JSON.stringify(args),
  }).then(handleErrors).then((r) => r.json());
}
export async function apiPost(path, args) {
  return fetch(`${path}`, {
    method: 'POST',
    body: args,
  }).then(handleErrors).then((r) => r.json());
}
export async function japiFile(path, args) {
  return fetch(`japi/${path}`, {
    method: 'POST',
    body: args,
  }).then(handleErrors).then((r) => r.json());
}
